<template>
  <div class="basic-info">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form
          class="ant-advanced-search-form"
          layout="inline"
          :form="form"
          @submit="handleSearch"
        >
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-form-item label="产品名称">
                <a-input
                  placeholder="请输入产品名称"
                  v-decorator="['fundName']"
                  allowClear
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="产品代码">
                <a-input
                  placeholder="请输入产品代码"
                  v-decorator="['fundCode']"
                  allowClear
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="8">
              <a-form-item label="定投时间">
                <a-range-picker
                  @change="handleChange"
                  :placeholder="['开始时间', '结束时间']"
                  :style="{width:'94%'}"
                  :value="createValue"
                  format="YYYY-MM-DD HH:mm:ss"
                 :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')]}"
                />
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleSearch" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="handleReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete" />批量删除</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          size="middle"
          bordered
          :columns="columns"
          :data-source="fixedHistoryList"
          rowKey="id"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          @change="handleTableChange"
        >
        </a-table>
      </div>
    </a-card>
  </div>
</template>
<script>
import moment from 'moment';
import { fixedHistory } from '@/api/api';
const columns = [
  {
    title: '产品名称',
    align: 'center',
    dataIndex: 'fundName',
    key: 'fundName',
    width: 200,
  },
  {
    title: '产品代码',
    align: 'center',
    dataIndex: 'fundCode',
    key: 'fundCode',
    width: 150,
  },
  {
    title: '定投时间',
    align: 'center',
    dataIndex: 'tradeTime',
    key: 'tradeTime',
    width: 200,
  },
  {
    title: '支付金额',
    align: 'center',
    dataIndex: 'applyAmount',
    key: 'applyAmount',
    width: 150,
  },
];
export default {
  data() {
    return {
      moment,
      queryParam: {
        tradeStartTime: '',
        tradeEndTime: '',
        fundName: '',
        fundCode: '',
      },
      createValue: [],
      columns,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      fixedHistoryList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      loading: false,
      selectedRowKeys: [],
      selectedRows: []
    };
  },
  created() {
    this.initTableData();
  },
  methods: {
    // 获取表格数据
    initTableData(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      this.form.validateFields((error, values) => {
        let params = {
          ...values,
          planId: this.$route.query.id,
          tradeStartTime: this.queryParam.tradeStartTime,
          tradeEndTime: this.queryParam.tradeEndTime,
          pageNo: this.ipagination.current,
          pageSize: this.ipagination.pageSize,
        };
        that.loading = true;
        fixedHistory(params).then((res) => {
          that.loading = false;
          if (res.success) {
            that.fixedHistoryList = res.result.records;
            that.loading = false;
            that.ipagination.total = res.result.total;
          }
        });
      });
    },
    // 清空表格选择
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    // 查询
    handleSearch(e) {
      e.preventDefault();
      this.initTableData();
    },
    // 重置
    handleReset() {
      this.form.resetFields();
      this.createValue = [];
      this.queryParam.tradeStartTime=""
      this.queryParam.tradeEndTime=""
      this.initTableData();
    },
    // 表格每项选择
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(selectionRows);
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initTableData();
    },
    //时间选择
    handleChange(date, dateString) {
      this.createValue = date;
      this.queryParam.tradeStartTime = dateString[0];
      this.queryParam.tradeEndTime = dateString[1];
    },
  },
};
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.ant-advanced-search-form {
  width: 100%;
  background: #fff;
}
.ant-advanced-search-form .ant-form-item {
  display: flex;
}
.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}
#components-form-demo-advanced-search .ant-form {
  max-width: none;
}
.table-operator {
  margin-bottom: 10px;
}
/deep/.expected-rate.ant-form-item
  .ant-form-item-control-wrapper
  .ant-form-item-control {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  width: 100%;
}
/deep/.expected-rate.ant-form-item
  .ant-form-item-control-wrapper
  .ant-form-item-control:hover {
  border-color: #40a9ff;
}
/deep/.expected-rate.ant-form-item
  .ant-form-item-control-wrapper
  .ant-form-item-children
  input {
  border: none;
  height: 28px;
}
/deep/.expected-rate.ant-form-item input:focus {
  box-shadow: none;
}
</style>
